import React from 'react'
import './skills.css'
import UIDesign from '../../assets/ui-design.png'
import WebDesign from '../../assets/website-design.png'
import AppDesign from '../../assets/app-design.png'

const Skills = () => {
  return (
    <section id='skills'>
        <span className="skillTitle">About Me</span>
        <span className="skillDesc">I am a student at the University of Wisconsin-Milwaukee studying Computer Science. My goal is to apply my knowledge and skills to develop solutions that address real-world challenges. I am driven by a passion for technology and a commitment to lifelong learning. Here are my skills below:</span>
        <div className="skillBars">
            <div className="skillBar">
                <img src={UIDesign} alt="UIDesign" className="skillBarImg" />
                <div className="skillBarText">
                    <h2>Languages / Technologies</h2>
                    <p>Python, Java, C, C++, JavaScript, TypeScript, HTML, CSS, SQL</p>
                </div>
            </div>
            <div className="skillBar">
                <img src={WebDesign} alt="WebDesign" className="skillBarImg" />
                <div className="skillBarText">
                    <h2>Frameworks / Libraries</h2>
                    <p>React, Django, JUnit, Spring Boot, Node.js, Bootstrap, Tailwind CSS, RESTful APIs</p>
                </div>
            </div>
            <div className="skillBar">
                <img src={AppDesign} alt="AppDesign" className="skillBarImg" />
                <div className="skillBarText">
                    <h2>Developer Tools / IDE</h2>
                    <p>Git, Linux, npm, Scrum, Trello</p>
                </div>
            </div>
        </div>
    </section>
  );
}

export default Skills;